import React, { useEffect, useState } from 'react';
import api from '../api';
import '../styles/CompletionPopup.css';

function CompletionPopup({ playerName, time, points, gameMode, rank, onLeaderboard, onPlayAgain }) {
  const [playersCount, setPlayersCount] = useState(0);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const data = await api.leaderboard();
        setPlayersCount(data.total);
      } catch (err) {
        console.error('Failed to fetch leaderboard:', err);
      }
    };

    fetchLeaderboard();
  }, []);


  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.round(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="completion-overlay">
      <div className="completion-popup">
        <h2>🎉 Game Complete!</h2>

        <div className="completion-stats">
          {gameMode === 'points' ? (
            <div className="stat">
              <span className="stat-label">Points:</span>
              <span className="stat-value">{points}</span>
            </div>
          ) : null}

          <div className="stat">
            <span className="stat-label">Time:</span>
            <span className="stat-value">{formatTime(time)}</span>
          </div>

          <div className="stat">
            <span className="stat-label">Rank:</span>
            <span className="stat-value">#{rank}</span>
          </div>

          {playersCount > 0 && (
            <div className="stat">
              <span className="stat-label">Total Players:</span>
              <span className="stat-value">{playersCount}</span>
            </div>
          )}
        </div>

        <div className="completion-actions">
          <button onClick={onLeaderboard} className="btn btn-primary">
            View Leaderboard
          </button>
          <button onClick={onPlayAgain} className="btn btn-secondary">
            Play Again Tomorrow
          </button>
        </div>
      </div>
    </div>
  );
}

export default CompletionPopup;
